module.exports = __webpack_public_path__ + "static/media/minus-circle.7a252632.svg";